export default {
  text: {
    en: 'Your {shippedMonth} package has been shipped. Check your tracking number.',
  },
  button: {
    en: 'Tracking number',
  },
}
